export const focusOutline =
  "outline-offset-1 focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-ignew-functional-focus-400";
